import React from "react";
import { FilterField, FilterGroup, FilterPanel, ListSearchForm } from "../../common/DataList";
import useAllRecipients from "./useAllRecipients";

// Recherche dans toutes les collections (flux, temporaires, stock) : quatre
// champs sur une ligne, « Rechercher » au bout. Mêmes clés envoyées à
// recipients/search-all ; le tableau de bord écrit aussi dans ces filtres.
export const DEFINITIONS_TOUS_ALLOCATAIRES = [
  { name: "lastname", label: "Nom", size: "md" },
  { name: "firstname", label: "Prénom", size: "md" },
  { name: "nir", label: "NIR", size: "md" },
  { name: "CAFId", label: "Matricule", size: "sm" },
];

const AllRecipientsFilters = () => {
  const {
    allRecipientsFilters,
    isAllRecipientsLoading,
    allRecipientsNbResults,
    onUpdateFilters,
    searchAllRecipients,
  } = useAllRecipients();

  const handleChangeFilters = (e) => {
    const { name, value } = e.target;
    onUpdateFilters({
      ...allRecipientsFilters,
      filters: {
        ...allRecipientsFilters.filters,
        [name]: value,
      },
    });
  };

  return (
    <ListSearchForm onSubmit={() => searchAllRecipients()} aria-label="Recherche dans tous les allocataires">
      <FilterPanel
        id="all-recipients-filters"
        title="Critères de recherche"
        inlineActions
        applyLabel="Rechercher"
        isLoading={isAllRecipientsLoading}
        footerInfo={<span role="status">{allRecipientsNbResults} résultat(s)</span>}
      >
        <FilterGroup title="Rechercher un allocataire par">
          {DEFINITIONS_TOUS_ALLOCATAIRES.map((definition) => (
            <FilterField
              key={definition.name}
              definition={definition}
              value={allRecipientsFilters.filters[definition.name]}
              onChange={handleChangeFilters}
              onSet={(name, value) => handleChangeFilters({ target: { name, value } })}
            />
          ))}
        </FilterGroup>
      </FilterPanel>
    </ListSearchForm>
  );
};

export default AllRecipientsFilters;
